module.exports = __webpack_public_path__ + "portal-static/img/safety_commitment.f09c9f3c.png";